export default __webpack_public_path__ + "static/media/P942_RoHS.c8ff1ee9.pdf";